module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/InsightStep3-9470d7c8e4efa5ec895ae9fb4cc26bac.jpg";